/**
 * Not for cryptographic use.
 */
export class Uuid {
	/**
	 * Generate UUID to prevent id clashes for screenreaders.
	 * This is *good enough* for ID generation.
	 */
	static next() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
}